module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', [_c('div', {
    staticClass: "intro-y box px-5 pt-5 mt-5"
  }, [_c('div', {
    staticClass: "flex flex-col lg:flex-row border-b border-gray-200 pb-5 -mx-5"
  }, [_c('div', {
    staticClass: "flex flex-1 px-5 items-center justify-center lg:justify-start"
  }, [_c('div', {
    staticClass: "w-20 h-20 sm:w-24 sm:h-24 flex-none lg:w-32 lg:h-32 image-fit relative"
  }, [(_vm.user && _vm.user.avatar) ? _c('img', {
    staticClass: "rounded-full",
    attrs: {
      "alt": "Profile",
      "src": _vm.user.avatar
    }
  }) : _c('img', {
    staticClass: "rounded-full",
    attrs: {
      "alt": "Profile",
      "src": "/static/images/profile.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ml-5"
  }, [_c('div', {
    staticClass: "truncate sm:whitespace-normal font-medium text-lg"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
    staticClass: "text-gray-600 mb-4"
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), _c('form', [_c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/png, image/jpeg"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), (_vm.loadImage) ? _c('div', {
    staticClass: "text-left"
  }, [_vm._m(1)]) : _c('label', {
    staticClass: "button bg-theme-10 text-white button-sm",
    attrs: {
      "for": "file"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cambiar Foto\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex mt-6 lg:mt-0 items-center lg:items-start flex-1 flex-col justify-center text-gray-600 px-5 border-l border-r border-gray-200 border-t lg:border-t-0 pt-5 lg:pt-0"
  }, [(_vm.user.profile) ? _c('div', {
    staticClass: "truncate sm:whitespace-normal flex items-center"
  }, [_vm._v("\n                  " + _vm._s(_vm.user.profile.name) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.user.team) ? _c('div', {
    staticClass: "truncate sm:whitespace-normal flex items-center mt-3"
  }, [_vm._v("\n                  " + _vm._s(_vm.user.team.name) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "truncate sm:whitespace-normal flex items-center mt-3"
  }, [_c('b', [_vm._v("ID compañia:")]), _vm._v("   " + _vm._s(_vm.user.id_company) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "truncate sm:whitespace-normal flex items-center mt-3"
  }, [_c('b', [_vm._v("Ingreso:")]), _vm._v("   " + _vm._s(_vm.user.admission_date) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "truncate sm:whitespace-normal flex items-center mt-3"
  }, [_c('b', [_vm._v("Nacimiento:")]), _vm._v("   " + _vm._s(_vm.user.birthday) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "truncate sm:whitespace-normal flex items-center mt-3"
  }, [_vm._v("\n                    Estas en MYINXAIT desde el " + _vm._s(_vm.user.created_at) + "\n                ")])]), _vm._v(" "), (_vm.user.team_id) ? _c('div', {
    staticClass: "w-20 h-20 px-5 sm:w-24 sm:h-24 mr-5 flex-none lg:w-32 lg:h-32 relative border-l hidden-xs border-gray-200"
  }, [_c('img', {
    staticClass: "mt-4",
    attrs: {
      "alt": "Team",
      "src": 'https://storage.googleapis.com/myinxait/teams/team-' + _vm.user.team_id + '.png'
    }
  })]) : _vm._e()]), _vm._v(" "), _vm._m(2)])]) : _c('app-loading')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-y flex items-center mt-8"
  }, [_c('h2', {
    staticClass: "text-lg font-medium mr-auto"
  }, [_vm._v("\n          Perfil\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Cargando...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-tabs flex flex-col sm:flex-row justify-center lg:justify-start hidden"
  }, [_c('a', {
    staticClass: "py-4 sm:mr-8 flex items-center active",
    attrs: {
      "data-toggle": "tab",
      "data-target": "#profile",
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "w-4 h-4 mr-2",
    attrs: {
      "data-feather": "user"
    }
  }), _vm._v(" Profile ")]), _vm._v(" "), _c('a', {
    staticClass: "py-4 sm:mr-8 flex items-center",
    attrs: {
      "data-toggle": "tab",
      "data-target": "#account",
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "w-4 h-4 mr-2",
    attrs: {
      "data-feather": "shield"
    }
  }), _vm._v(" Account ")]), _vm._v(" "), _c('a', {
    staticClass: "py-4 sm:mr-8 flex items-center",
    attrs: {
      "data-toggle": "tab",
      "data-target": "#change-password",
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "w-4 h-4 mr-2",
    attrs: {
      "data-feather": "lock"
    }
  }), _vm._v(" Change Password ")]), _vm._v(" "), _c('a', {
    staticClass: "py-4 sm:mr-8 flex items-center",
    attrs: {
      "data-toggle": "tab",
      "data-target": "#settings",
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "w-4 h-4 mr-2",
    attrs: {
      "data-feather": "settings"
    }
  }), _vm._v(" Settings ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-041d138f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/user/AdminProfile.vue
// module id = 403
// module chunks = 1